// extracted by mini-css-extract-plugin
export var banner = "_3g-0";
export var icon = "_3g-1";
export var message = "_3g-2";